<template>
  <div class="courseArrangement">
    <div v-if="currentCourse.length > 0" class="currentCourse coursemeeting">
      <div class="list-title">当前安排</div>
      <div class="content">
        <div
          class="list-item"
          v-for="(item, index) in currentCourse"
          :key="index"
        >
          <div class="list-item-content">
            <div class="list-item-top" @click="signIn(item)">
              <div class="list-item-title">
                <div class="list-item-title-text">{{ item.name }}</div>
                <van-icon name="arrow" size="0.2rem" color="#999" />
              </div>
              <div class="classname" v-if="item.className">{{ item.className }}</div>
            </div>
            <div class="list-item-bottom">
              <van-row gutter="20">
                <van-col span="12">
                  <div class="bottomcontent">
                    <div class="label">上课地点</div>
                    <div class="bottom-text">
                      {{ item.place ? item.place : "暂无" }}
                    </div>
                  </div>
                </van-col>
                <van-col span="12">
                  <div class="bottomcontent">
                    <div class="label">上课时间</div>
                    <div class="bottom-text">
                      {{ item.affairDate }} {{ item.beginTime }}-{{
                        item.endTime
                      }}
                    </div>
                  </div>
                </van-col>
              </van-row>
            </div>
          </div>
          <div
            class="list-item-grey"
            v-show="currentCourse.length - 1 != index"
          ></div>
        </div>
      </div>
    </div>
    <div class="notOpenCourse coursemeeting">
      <div class="list-title">未开始安排</div>
      <div class="content" v-if="notOpenCourse.length > 0">
        <div
          class="list-item"
          v-for="(item, index) in notOpenCourse"
          :key="index"
        >
          <div class="list-item-content">
            <div class="list-item-top">
              <div class="list-item-title">
                <div class="list-item-title-text">{{ item.name }}</div>
              </div>
              <div class="classname" v-if="item.className">{{ item.className }}</div>
            </div>
            <div class="list-item-bottom">
              <van-row gutter="20">
                <van-col span="12">
                  <div class="bottomcontent">
                    <div class="label">上课地点</div>
                    <div class="bottom-text">
                      {{ item.place ? item.place : "暂无" }}
                    </div>
                  </div>
                </van-col>
                <van-col span="12">
                  <div class="bottomcontent">
                    <div class="label">上课时间</div>
                    <div class="bottom-text">
                      {{ item.affairDate }} {{ item.beginTime }}-{{
                        item.endTime
                      }}
                    </div>
                  </div>
                </van-col>
              </van-row>
            </div>
          </div>
          <div
            class="list-item-grey"
            v-show="notOpenCourse.length - 1 != index"
          ></div>
        </div>
      </div>
      <div v-else class="arrange-nodata">
        <div class="nodatacontent">
          <img
            :src="require('_teas/public/img/product/bootScreen/img-null.png')"
            alt=""
            srcset=""
          />
          <div class="text">暂无课程</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 课程安排
export default {
  name: "courseArrangement",
  data() {
    return {
      currentCourse: [], //当前课程
      notOpenCourse: [], //未开课程
    };
  },
  methods: {
    //跳转签到
    signIn(item) {
      var url =
        "/mobile/bootScreen/attendance?id=" +
        item["id"] +
        "&relId=" +
        item["relId"] +
        "&courseNoonId=" +
        item["courseNoonId"] +
        "&type=" +
        item["typeValue"] +
        "&attendMode=" +
        item["courseAttendMode"];
      this.$router.push({
        path: url,
      });
    },
    dealData(data) {
      var left = data["1"];
      if (left) {
        this.currentCourse = left;
      }
      var right = data["2"];
      if (right) {
        this.notOpenCourse = right;
      }
    },
    //获取数据
    getData() {
      var loading = dsf.layer.loading();
      this.$http
        .get("teas/screen/getSameDayClassroomArrangement", {
          equipmentId: sessionStorage.getItem('equipmentId'),
        })
        .done((res) => {
          console.log(res);
          if (res.success && res.state == 20000) {
            this.dealData(res.data);
          } else {
            this.$message(res.message, false);
          }
        })
        .error((err) => {
          this.$message("请求失败", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>